import React from 'react';
import { useInView } from 'react-intersection-observer';
import Educate from "./img/Educate.jpg";
import Enrich from "./img/Enrichjpg.jpg";
import Empower from "./img/Empower.jpg";
import Holistic from "./img/Holistic.jpg"; // Naya image import kar lena yaha

const TeamMember = () => {
  const { ref: card1Ref, inView: card1InView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const { ref: card2Ref, inView: card2InView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const { ref: card3Ref, inView: card3InView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const { ref: card4Ref, inView: card4InView } = useInView({ triggerOnce: true, threshold: 0.1 }); // 4th Card Ref

  return (
    <div id="ultra-premium-programs">
      <style>
        {`
          #ultra-premium-programs {
            /* Logo Theme Colors */
            --brand-pink: #ec1c74;
            --brand-blue: #00a8e8;
            --bg-color: #fbfcfd;
            --card-bg: rgba(255, 255, 255, 0.7);
            --card-border: rgba(255, 255, 255, 0.9);
            --text-dark: #1d1d1f;
            --text-muted: #6e6e73;
            
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            
            /* Subtle mesh gradient using logo colors for that Apple luxury feel */
            background: radial-gradient(circle at 0% 0%, rgba(0, 168, 232, 0.05) 0%, transparent 50%), 
                        radial-gradient(circle at 100% 100%, rgba(236, 28, 116, 0.05) 0%, transparent 50%);
            background-color: var(--bg-color);
            padding: 5rem 2rem;
            box-sizing: border-box;
          }

          #ultra-premium-programs * {
            box-sizing: border-box;
          }

          #ultra-premium-programs .premium-container {
            max-width: 1200px;
            margin: 0 auto;
          }

          /* Fixed 2x2 Grid for Perfect Symmetry */
          #ultra-premium-programs .programs-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2.5rem;
          }

          #ultra-premium-programs .premium-card {
            background: var(--card-bg);
            backdrop-filter: blur(24px);
            -webkit-backdrop-filter: blur(24px);
            border: 1px solid var(--card-border);
            border-radius: 32px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
            opacity: 0;
            transform: translateY(40px);
            transition: opacity 0.8s ease-out, transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1), box-shadow 0.4s ease, border-color 0.4s ease;
            display: flex;
            flex-direction: column;
          }

          #ultra-premium-programs .premium-card.animate {
            opacity: 1;
            transform: translateY(0);
          }

          /* Hover state with subtle brand color glow */
          #ultra-premium-programs .premium-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 25px 50px rgba(236, 28, 116, 0.08);
            border-color: rgba(236, 28, 116, 0.2);
            background: rgba(255, 255, 255, 0.95);
          }

          #ultra-premium-programs .image-wrapper {
            width: 100%;
            height: 260px;
            overflow: hidden;
            position: relative;
          }

          #ultra-premium-programs .image-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
          }

          #ultra-premium-programs .premium-card:hover .image-wrapper img {
            transform: scale(1.06);
          }

          /* Subtle gradient overlay on images */
          #ultra-premium-programs .image-wrapper::after {
            content: '';
            position: absolute;
            bottom: 0; left: 0; right: 0;
            height: 40%;
            background: linear-gradient(to top, rgba(0,0,0,0.1), transparent);
          }

          #ultra-premium-programs .card-content {
            padding: 2.5rem 2rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
          }

          #ultra-premium-programs .card-title {
            font-size: 1.6rem;
            font-weight: 700;
            color: var(--text-dark);
            margin: 0 0 1.2rem 0;
            letter-spacing: -0.01em;
          }

          #ultra-premium-programs .card-text-group {
            margin-bottom: 1.2rem;
          }

          /* Logo Colors applied to labels */
          #ultra-premium-programs .card-label {
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 0.12em;
            color: var(--brand-pink);
            font-weight: 700;
            display: block;
            margin-bottom: 0.4rem;
          }

          #ultra-premium-programs .card-label.treatment-label {
            color: var(--brand-blue);
          }

          #ultra-premium-programs .card-desc {
            font-size: 1.05rem;
            line-height: 1.6;
            color: var(--text-muted);
            margin: 0;
          }

          /* Responsive adjustments */
          @media (max-width: 992px) {
            #ultra-premium-programs .programs-grid {
              grid-template-columns: 1fr; /* Switch to 1 column on smaller screens */
            }
            #ultra-premium-programs .image-wrapper {
              height: 220px;
            }
          }

          @media (max-width: 768px) {
            #ultra-premium-programs {
              padding: 3rem 1rem;
            }
            #ultra-premium-programs .card-content {
              padding: 2rem 1.5rem;
            }
            #ultra-premium-programs .card-title {
              font-size: 1.4rem;
            }
          }
        `}
      </style>

      <div className="premium-container">
        <div className="programs-grid">
          
          {/* Card 1 */}
          <div ref={card1Ref} className={`premium-card ${card1InView ? 'animate' : ''}`}>
            <div className="image-wrapper">
              <img src={Educate} alt="Alcohol Recovery Program" />
            </div>
            <div className="card-content">
              <h5 className="card-title">Alcohol Recovery Program</h5>
              
              <div className="card-text-group">
                <span className="card-label">Description</span>
                <p className="card-desc">Alcohol dependency is handled with profound care at our Wellness Center. This treatment focuses on helping individuals manage withdrawal symptoms, comfortably control cravings, and implement lifestyle changes to maintain a healthy life.</p>
              </div>

              <div className="card-text-group">
                <span className="card-label treatment-label">Treatment</span>
                <p className="card-desc">Holistic cleansing, personalized counseling, and group therapies are utilized. Our behavioral therapies help individuals understand their triggers and develop healthier, long-lasting coping mechanisms.</p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div ref={card2Ref} className={`premium-card ${card2InView ? 'animate' : ''}`}>
            <div className="image-wrapper">
              <img src={Enrich} alt="Substance Recovery Program" />
            </div>
            <div className="card-content">
              <h5 className="card-title">Substance Recovery Program</h5>
              
              <div className="card-text-group">
                <span className="card-label">Description</span>
                <p className="card-desc">Our Wellness Center is dedicated to helping individuals overcome dependence on various substances. It's a structured, multi-step process that includes safe cleansing, mindful therapy, and continuous aftercare support.</p>
              </div>

              <div className="card-text-group">
                <span className="card-label treatment-label">Treatment</span>
                <p className="card-desc">Treatment involves medically-assisted care, one-on-one counseling, and behavioral therapy. We also provide family counseling to help repair relationships and foster a deeply supportive home environment.</p>
              </div>
            </div>
          </div>
          
          {/* Card 3 */}
          <div ref={card3Ref} className={`premium-card ${card3InView ? 'animate' : ''}`}>
            <div className="image-wrapper">
              <img src={Empower} alt="Behavioral Wellness Program" />
            </div>
            <div className="card-content">
              <h5 className="card-title">Behavioral Wellness Program</h5>
              
              <div className="card-text-group">
                <span className="card-label">Description</span>
                <p className="card-desc">Behavioral challenges, such as gaming or internet overuse, are treated at our Wellness Center to help individuals manage compulsive behavior without substances, focusing heavily on behavioral modification.</p>
              </div>

              <div className="card-text-group">
                <span className="card-label treatment-label">Treatment</span>
                <p className="card-desc">Cognitive-behavioral therapy (CBT) and mindfulness practices help individuals recognize underlying patterns, build healthier daily habits, and develop ultimate self-control for a balanced life.</p>
              </div>
            </div>
          </div>

          {/* Card 4 - New Card Added for Grid Balance */}
          <div ref={card4Ref} className={`premium-card ${card4InView ? 'animate' : ''}`}>
            <div className="image-wrapper">
              <img src={Holistic} alt="Family & Holistic Wellness" /> 
            </div>
            <div className="card-content">
              <h5 className="card-title">Family & Holistic Wellness</h5>
              
              <div className="card-text-group">
                <span className="card-label">Description</span>
                <p className="card-desc">Healing extends beyond the individual. Our family-focused wellness programs foster a supportive home environment, integrating yoga, meditation, and mindfulness to promote overall well-being and inner peace.</p>
              </div>

              <div className="card-text-group">
                <span className="card-label treatment-label">Treatment</span>
                <p className="card-desc">Group family sessions, guided meditation, nutritional planning, and wellness workshops designed to build a harmonious, deeply connected, and balanced lifestyle for everyone involved.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TeamMember;